import { Component } from '@angular/core';
import { JsxgraphComponent, type JsxgraphBoard } from '@examdojo/core/jsxgraph';

@Component({
  selector: 'dojo-multi-graph-example',
  standalone: true,
  imports: [JsxgraphComponent],
  template: `
    <div class="grid h-full w-full gap-4 p-4" style="grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));">
      <div class="flex flex-col gap-2">
        <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">Parabola</h3>
        <div class="h-full min-h-[350px]">
          <dojo-jsxgraph [boardId]="'parabola'" [options]="boardOptions" (boardReady)="onParabolaReady($event)" />
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">Exponential</h3>
        <div class="h-full min-h-[350px]">
          <dojo-jsxgraph [boardId]="'exponential'" [options]="boardOptions" (boardReady)="onExponentialReady($event)" />
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">Logarithm</h3>
        <div class="h-full min-h-[350px]">
          <dojo-jsxgraph [boardId]="'logarithm'" [options]="boardOptions" (boardReady)="onLogarithmReady($event)" />
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">Tangent</h3>
        <div class="h-full min-h-[350px]">
          <dojo-jsxgraph [boardId]="'tangent'" [options]="boardOptions" (boardReady)="onTangentReady($event)" />
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        @apply block h-full w-full overflow-auto;
      }
    `,
  ],
  host: { class: 'block h-full w-full' },
})
export class MultiGraphExampleComponent {
  readonly boardOptions = {
    boundingbox: [-5, 5, 5, -5] as [number, number, number, number],
    axis: true,
    showNavigation: false,
    showCopyright: false,
  };

  onParabolaReady(board: JsxgraphBoard): void {
    board.create('functiongraph', [(x: number) => x * x, -5, 5], {
      strokeColor: '#ff6b6b',
      strokeWidth: 2,
    });

    board.create('text', [-4, 4, 'f(x) = x²'], {
      fontSize: 14,
      color: '#ff6b6b',
    });
  }

  onExponentialReady(board: JsxgraphBoard): void {
    board.create('functiongraph', [(x: number) => Math.exp(x / 2), -5, 5], {
      strokeColor: '#4ecdc4',
      strokeWidth: 2,
    });

    board.create('text', [-4, 4, 'f(x) = e^(x/2)'], {
      fontSize: 14,
      color: '#4ecdc4',
    });
  }

  onLogarithmReady(board: JsxgraphBoard): void {
    board.create('functiongraph', [(x: number) => Math.log(x), 0.1, 5], {
      strokeColor: '#95e1d3',
      strokeWidth: 2,
    });

    board.create('text', [2, 3, 'f(x) = ln(x)'], {
      fontSize: 14,
      color: '#95e1d3',
    });
  }

  onTangentReady(board: JsxgraphBoard): void {
    board.create('functiongraph', [(x: number) => Math.tan(x), -Math.PI / 2 + 0.1, Math.PI / 2 - 0.1], {
      strokeColor: '#f38181',
      strokeWidth: 2,
    });

    board.create('text', [-1, 4, 'f(x) = tan(x)'], {
      fontSize: 14,
      color: '#f38181',
    });
  }
}
